import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { Box, Button, SimpleGrid, VStack } from "@chakra-ui/react";
import { jsPDF } from "jspdf";

import { getInvoice, getPayInvoiceLink } from "api/webservice/invoice";
import { AuthenticatedLayout } from "layouts";
import { Invoice as InvoiceType, InvoiceStatus } from "types/invoice";
import { padNum } from "utils";
import PDF from "./Pdf";
import { useToast } from "hooks";

interface Props {
  invoiceId: string;
}

const Invoice: React.FC<RouteComponentProps<Props>> = ({
  match
}: RouteComponentProps<Props>) => {
  const { invoiceId } = match.params;
  const [invoice, setInvoice] = useState<InvoiceType>();
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handlePayClick = (): void => {
    if (loading) return;
    setLoading(true);
    getPayInvoiceLink(invoiceId)
      .then(link => {
        setLoading(false);
        window.open(link, "_blank");
      })
      .catch(error => {
        setLoading(false);
        toast({
          title: "",
          description: error.response.data.response,
          status: "error"
        });
      });
  };

  const downloadPDF = async (): Promise<void> => {
    if (!invoice) return;
    const pages = document.getElementById("toPrint");
    if (!pages) return;

    const doc = new jsPDF("p", "pt", undefined, true);

    await doc.html(pages);

    doc.save(
      `${invoice.organization.displayName} Invoice ${padNum(
        invoice.invoice_num,
        5
      )}.pdf`
    );
  };

  useEffect(() => {
    getInvoice(invoiceId).then(invoice => setInvoice(invoice));
  }, [setInvoice]);

  return (
    <AuthenticatedLayout>
      <VStack spacing={8} width="100%">
        <SimpleGrid columns={2} gap={5}>
          <Button onClick={() => downloadPDF()}>Print</Button>
          <Button
            isLoading={loading}
            variant="green"
            onClick={handlePayClick}
            hidden={
              invoice?.status == InvoiceStatus.Paid ||
              invoice?.status == InvoiceStatus.Void
            }
          >
            Pay
          </Button>
        </SimpleGrid>
        <Box>{invoice && <PDF invoice={invoice} />}</Box>
      </VStack>
    </AuthenticatedLayout>
  );
};

export default Invoice;
